import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMetaLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 287 191",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M31.06 125.96c0 11.06 2.43 19.55 5.62 24.68 4.16 6.74 10.39 9.59 16.73 9.59 8.18 0 15.66-2.03 30.07-21.96 11.55-15.99 25.18-38.42 34.36-52.49l15.55-23.88c10.78-16.59 23.27-35.04 37.59-47.55C182.66 4.05 195.39 0 208.21 0c21.52 0 42.03 12.48 57.72 35.88C283.13 61.46 291.46 93.66 291.46 126.93c0 19.78-3.9 34.32-10.54 45.81-6.41 11.11-18.91 22.21-39.94 22.21V162.65c18.01 0 22.51-16.55 22.51-35.5 0-26.99-6.29-56.95-20.16-78.34-9.85-15.16-22.61-24.43-36.66-24.43-15.18 0-27.41 11.45-41.15 31.85-7.31 10.83-14.81 24.04-23.23 38.94l-9.17 16.23c-18.43 32.65-23.1 40.07-32.31 52.31-16.16 21.46-29.97 29.55-48.18 29.55-21.74 0-35.46-9.41-43.95-23.59-7-11.55-10.43-26.7-10.43-43.99l30.81.27z",
			fill: "#0081FB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.55 38.07C39.08 15.66 60.06 0 84.13 0c13.94 0 27.79 4.12 42.26 15.94 15.83 12.93 32.69 34.21 53.74 69.31l7.55 12.58c18.21 30.34 28.57 45.94 34.63 53.31 7.79 9.47 13.24 12.29 20.32 12.29 18.01 0 22.51-16.55 22.51-35.5l27.18-.85c0 19.78-3.9 34.32-10.54 45.81-6.41 11.11-18.91 22.21-39.94 22.21-13.07 0-24.65-2.84-37.45-14.91-9.84-9.28-21.35-25.76-30.21-40.58l-26.36-44.04c-13.22-22.1-25.35-38.57-32.37-46.03-7.55-8.02-17.25-17.72-32.74-17.72-12.54 0-23.18 8.8-32.09 22.26L24.55 38.07z",
			fill: "url(#meta-gradient-a)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M83.64 28.41c-12.54 0-23.18 8.8-32.09 22.26-12.6 19.01-20.31 47.32-20.31 74.49 0 11.06 2.43 19.55 5.62 24.68L10.4 165.95C3.4 154.4-.03 139.25-.03 121.96-.03 90.55 8.6 57.81 24.55 38.07 39.08 15.66 60.06 0 84.13 0l-.49 28.41z",
			fill: "url(#meta-gradient-b)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "meta-gradient-a",
			x1: 61.66,
			y1: 64.79,
			x2: 259.59,
			y2: 74.71,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#0064E1" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .4,
					stopColor: "#0064E1"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .83,
					stopColor: "#0073EE"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#0082FB"
				})
			]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "meta-gradient-b",
			x1: 41.93,
			y1: 138.41,
			x2: 41.93,
			y2: 65.51,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0082FB" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0064E0"
			})]
		})] })
	]
});
export default SvgMetaLogo;
